import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  margin: theme.spacing(0.5, 1),
  transition: 'all 0.3s ease',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  '&::before': { 
    content: '""', 
    position: 'absolute', 
    left: 0, top: 0, bottom: 0, 
    width: '0px', 
    background: `linear-gradient(to bottom, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`, 
    borderRadius: theme.spacing(0, 1, 1, 0), 
    transition: 'all 0.3s ease' 
  },
  '&.Mui-selected': { 
    backgroundColor: alpha(theme.palette.primary.main, 0.1), 
    '&::before': { width: '4px' }, 
    '& .MuiListItemIcon-root': { color: theme.palette.primary.main }, 
    '& .MuiTypography-root': { fontWeight: 600, background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`, backgroundClip: 'text', WebkitBackgroundClip: 'text', color: 'transparent' } 
  },
  '&:hover': { 
    backgroundColor: alpha(theme.palette.primary.main, 0.05), 
    transform: 'translateX(4px)', 
    '&::before': { width: '4px' }, 
    '& .MuiListItemIcon-root': { transform: 'scale(1.1)', color: theme.palette.primary.main }, 
    '& .MuiTypography-root': { background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`, backgroundClip: 'text', WebkitBackgroundClip: 'text', color: 'transparent' } 
  },
}));

const AdminAddressButton = ({ path = '/admin/addresses', onClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSelected = location.pathname === path;
  const handleClick = (e) => { if (onClick) onClick(e); else navigate(path); };
  return (
    <StyledListItemButton onClick={handleClick} selected={isSelected}>
      <ListItemIcon><LocationOnIcon /></ListItemIcon>
      <ListItemText primary="Add Address" />
    </StyledListItemButton>
  );
};

export default AdminAddressButton;